if (!customElements.get('rj-product-finishes')) {
  customElements.define('rj-product-finishes', class extends HTMLElement {
    connectedCallback() {
      this.info = this.closest('product-info');
      this.onChange = (event) => {
        if (!event.target.closest('variant-selects')) return;
        const option = this.info.querySelector('variant-selects fieldset input:checked, variant-selects select');
        if (!option) return;
        this.querySelectorAll('a[data-variants]').forEach(link => {
          const match = JSON.parse(link.dataset.variants).find(variant => variant.option === option.value);
          if (match) link.href = match.url;
        });
      };
      this.info?.addEventListener('change', this.onChange);
    }
    disconnectedCallback() { this.info?.removeEventListener('change', this.onChange); }
  });
}
